const CardData2 = [
  {
    title: 'Gloria Trevi',
    description:'Gloria de los Ángeles Treviño Ruiz (Monterrey, Nuevo León, 15 de febrero de 1968), conocida artísticamente como Gloria Trevi, es una cantante, actriz, productora, compositora y empresaria mexicana.En 1985 se mudó a la Ciudad de México para comenzar su carrera artística. Allí conoció al productor y arreglista Sergio Andrade, quien formó el grupo musical "Boquitas Pintadas". Cuatro años más tarde, de la mano de Andrade, publicó su álbum debut ...Qué hago aquí? , distribuido por BMG Ariola. En los 90, debutó en el cine con tres películas: Pelo suelto (1991), Zapatos viejos (1993) y Una papa sin catsup (1995). Terminó la década con cinco álbumes que sumaban casi 5 millones de ventas.',
    videourl:'https://youtube.com/playlist?list=PLszZ23pLzkUvIXPmh_x5TGeVpTazENODe',
    price: '$50',
    coverImg: 'gloriatrevi.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://gloriatrevi.lnk.to/IslaDivinaAlbum!YTD',
    youtube: 'https://www.youtube.com/channel/UCNZazBoobtvziOGR65QQVog',
    facebook: 'https://www.facebook.com/GloriaTreviOficial',
    instagram: 'https://www.instagram.com/gloriatrevi/',
    twitter: 'https://twitter.com/GloriaTrevi',
    spotify: 'https://open.spotify.com/artist/1Db5GsIoVWYktPoD2nnPZZ',
    deezer: 'https://www.deezer.com/mx/artist/7218',
    apple: 'https://music.apple.com/mx/artist/gloria-trevi/6711586',
    soundcloud: 'https://soundcloud.com/gloria-trevi-official',
    tidal: 'https://listen.tidal.com/artist/3752902',
    wiki: 'https://es.wikipedia.org/wiki/Gloria_Trevi',
    ticketmaster:'https://www.ticketmaster.com/gloria-trevi-tickets/artist/956252',
    tiktok: 'https://www.tiktok.com/@gloriatrevioficial',
    napster: 'https://music.amazon.com.mx/artists/B00130DI78/gloria-trevi',
  },

  {
    title: 'Jorge Negrete',
    description:'Jorge Alberto Negrete Moreno (Guanajuato, 30 de noviembre de 1911-Los Ángeles, California, 5 de diciembre de 1953), conocido como El Charro Cantor, fue un actor y cantante mexicano. Fundó el Sindicato de Trabajadores de la Producción Cinematográfica de la República Mexicana1​ y reorganizó, junto con un grupo selecto de actores, la Asociación Nacional de Actores.',
    videourl:'https://youtube.com/playlist?list=PLF-cRDh2mrlVngSBUUO1Yyb7E9KNPUvjl',
    price: '$50',
    coverImg: 'jorgenegrete2.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: '.',
    youtube: 'https://www.youtube.com/c/jorgenegretefans',
    facebook: 'https://www.facebook.com/profile.php?id=100059758101482',
    instagram: 'https://www.instagram.com/jorgenegreteforever/',
    twitter: 'https://twitter.com/DonJorgeNegrete',
    spotify: 'https://open.spotify.com/artist/4W5RbLZybsLfAzE7QqdibE',
    deezer: 'https://www.deezer.com/mx/artist/299515',
    soundcloud: 'https://soundcloud.com/jorgenegreteofficial',
    tidal: 'https://listen.tidal.com/artist/3661015',
    wiki: 'https://es.wikipedia.org/wiki/Jorge_Negrete',
    ticketmaster:'https://www.ticketmaster.com.mx/teatro-jorge-negrete-boletos-mexico/venue/163990',
    napster: 'https://web.napster.com/artist/art.50312',
    tiktok: 'https://www.tiktok.com/search?q=Jorge%20Negrete&t=1667333198086',
  },
  {
    title: 'Rocio Durcal',
    description:'María de los Ángeles de las Heras Ortiz, conocida por su nombre artístico Rocío Dúrcal, fue una actriz y cantante española. Dúrcal es considerada como la «reina de las rancheras» y es una de las mujeres de habla hispana con más ventas en la industria. En 2005, un año antes de su muerte, recibió el Grammy Latino a la excelencia musical.',
    videourl:'http://youtube.com/playlist?list=OLAK5uy_lMv8ZIewIbDR8z4ckj4pbzhXV8GtrWh58',
    price: '$50',
    coverImg: 'rociodurcal.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://es.wikipedia.org/wiki/Roc%C3%ADo_D%C3%BArcal',
    youtube: 'https://www.youtube.com/channel/UCBgAZZ95M0pSBo69Qb6EuTQ',
    facebook: 'https://www.facebook.com/RocioDurcalMusic',
    instagram:'https://www.instagram.com/rociodurcal.music/?fbclid=IwAR1j7EblxeIYpgKWQfpesMeVe2l-6TfNhzfv7Hterp7PVJPLcWjCSPR6n_I',
    twitter:'https://twitter.com/rocio_durcal?fbclid=IwAR0QUd4K5u9dWS3S72dobhOD_ktY5dPbr-386AiKlv411DTQPTAhsnOY-vA',
    spotify: 'https://open.spotify.com/artist/2uyweLa0mvPZH6eRzDddeB',
    deezer: 'https://www.deezer.com/mx/artist/75284',
    apple: 'https://music.apple.com/mx/artist/roc%C3%ADo-d%C3%BArcal/6742584',
    soundcloud: 'https://soundcloud.com/rocio-durcal-official',
    tidal: 'https://listen.tidal.com/artist/3660925',
    wiki: 'https://en.wikipedia.org/wiki/Roc%C3%ADo_D%C3%BArcal',
    ticketmaster:
      'https://www.ticketmaster.com/rocio-durcal-tickets/artist/754908',
    napster: 'https://web.napster.com/artist/rocio-durcal-latin',
    tiktok: 'https://www.tiktok.com/@rociodurcal.oficial',
  },
  {
    title: 'Jose Alfredo Jimenez',
    description:'José Alfredo Jiménez Sandoval (Dolores Hidalgo, Guanajuato, 19 de enero de 1926-Ciudad de México, 23 de noviembre de 1973) fue un cantante y compositor mexicano. Jiménez fue el autor de varios temas musicales del género regional mexicano, específicamente de rancheras, sones, corridos, y huapangos a ritmo de mariachi.',
    videourl:'http://youtube.com/playlist?list=OLAK5uy_k2kN1d58ypIxZcl6DEtIT_2tsuaZpeWJM',
    price: '$50',
    coverImg: 'JoseAlfredo.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://es.wikipedia.org/wiki/Jos%C3%A9_Alfredo_Jim%C3%A9nez',
    youtube: 'https://www.youtube.com/channel/UC3w7TN1QkWk9ecC0q_ebm7Q',
    facebook: 'https://www.facebook.com/JoseAlfredoJimenezElRey/',
    instagram: 'https://www.instagram.com/josealfredojimenezoficial/',
    twitter: 'https://twitter.com/JoseAlfredoJmz',
    spotify: 'https://open.spotify.com/artist/2T06whb4s6UiufL1j5Qtz9',
    deezer: 'https://www.deezer.com/mx/artist/343074',
    apple:'https://music.apple.com/mx/artist/jos%C3%A9-alfredo-jim%C3%A9nez/332254',
    soundcloud: 'https://soundcloud.com/josealfredojimenez',
    tidal: 'https://listen.tidal.com/artist/4029320',
    wiki: 'https://en.wikipedia.org/wiki/Jos%C3%A9_Alfredo_Jim%C3%A9nez',
    ticketmaster:'https://www.ticketmaster.com/jose-alfredo-jimenez-medel-tickets/artist/2036602',
    tiktok:'https://www.tiktok.com/search?q=Jos%C3%A9%20Alfredo%20Jim%C3%A9nez&t=1658091294171',
    napster: 'https://web.napster.com/artist/jose-alfredo-jimenez',
  },
  {
    title: 'Juan Gabriel',
    description:'Alberto Aguilera Valadez, conocido como Juan Gabriel, fue un cantante, compositor, arreglista, productor musical, músico, filántropo y actor mexicano. Son notables sus contribuciones a la música popular en español en diferentes géneros como balada, ranchera, bolero, pop, música norteña, rumba flamenca, huapango, música chicana, salsa, cumbia, tango, polka, samba, vals, son de mariachi, joropo, banda sinaloense, disco, jazz, new age, country, rock and roll, big band y hasta canciones de cuna que escribió a cada uno de sus hijos.',
    videourl:'http://youtube.com/playlist?list=OLAK5uy_ldwlb88-oemhNHFY2wJDvWnwu56vjdy2o',
    price: '$50',
    coverImg: 'JuanGabriel.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://juangabriel.com/',
    youtube: 'https://www.youtube.com/channel/UCnLJnKKCxLRsAktAB9iMSeQ',
    facebook: 'https://www.facebook.com/JuanGabrielPorLosSiglos',
    instagram: 'https://www.instagram.com/soyjuangabriel_/?hl=en',
    twitter: 'https://twitter.com/soyjuangabriel',
    spotify: 'https://open.spotify.com/artist/2MRBDr0crHWE5JwPceFncq',
    deezer: 'https://www.deezer.com/mx/artist/71813',
    apple: 'https://music.apple.com/mx/artist/juan-gabriel/295294',
    soundcloud: 'https://soundcloud.com/juan-gabriel-official',
    tidal: 'https://listen.tidal.com/artist/4347',
    wiki: 'https://en.wikipedia.org/wiki/Juan_Gabriel',
    ticketmaster:
      'https://www.ticketmaster.com/juan-gabriel-tickets/artist/761622',

    tiktok: 'https://www.tiktok.com/@soyjuangabriel',
    napster: 'https://web.napster.com/artist/juan-gabriel',
  },
  {
    title: 'Jose Jose',
    description:'José Rómulo Sosa Ortiz (Clavería, Azcapotzalco, Ciudad de México, 17 de febrero de 1948-Homestead, Florida, 28 de septiembre de 2019), conocido como José José, fue un cantante y actor mexicano. Se le considera como un icono musical',
    videourl: 'https://youtube.com/playlist?list=PL26274DCDCD4770D8',
    price: '$50',
    coverImg: 'josejose.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://es.wikipedia.org/wiki/Jos%C3%A9_Jos%C3%A9',
    youtube: 'https://www.youtube.com/channel/UCSPwNgHHyAtHanVaGN2LLWA',
    facebook: 'https://www.facebook.com/OficialJoseJose',
    instagram: 'https://www.instagram.com/explore/tags/josejose/?hl=en',
    twitter: 'https://twitter.com/JoseJoseOficial',
    spotify: 'https://open.spotify.com/artist/4mN0qcMxWX8oToqfDPM5yV',
    deezer: 'https://www.deezer.com/mx/artist/71835',
    apple: 'https://music.apple.com/mx/artist/jos%C3%A9-jos%C3%A9/333303',
    soundcloud: 'https://soundcloud.com/jose-jose-official',
    tidal: 'https://listen.tidal.com/artist/4343',
    wiki: 'https://es.wikipedia.org/wiki/Jos%C3%A9_Jos%C3%A9',
    ticketmaster:
      'https://www.ticketmaster.com/jose-jose-tickets/artist/756645',
    tiktok: 'https://www.tiktok.com/@josejoseoficial',
    napster: 'https://web.napster.com/artist/jose-jose',
  },
  {
    title: 'Los Panchos',
    description:'Los Panchos fueron un trío musical romántico internacional formado por los mexicanos Chucho Navarro y Alfredo Gil y el puertorriqueño Hernando Avilés en la década de los 40 en la Ciudad de México. Se les considera como uno de los mejores tríos musicales y uno de los artistas latinoamericanos más influyentes de todos los tiempos,siendo populares en todo el mundo. Han celebrado conciertos durante más de 70 años y han aparecido en más de 50 películas. El trío se convirtió en uno de los máximos exponentes del bolero y la balada romántica en Latinoamérica.',
    videourl: 'https://youtube.com/playlist?list=UUnEk7ymV4bZlk2MW-kir9dw',
    price: '$50',
    coverImg: 'LosPanchos.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://es.wikipedia.org/wiki/Los_Panchos',
    youtube: 'https://www.youtube.com/channel/UCnEk7ymV4bZlk2MW-kir9dw',
    facebook: 'https://www.facebook.com/lospanchosoficial',
    instagram:'https://www.instagram.com/triolospanchosoficial/?fbclid=IwAR0ZUMwr8iIqJ3cb0qIS3qScxN57NVkXOMhHZFdvKcu64f5boNfeRD5EhsU',
    twitter: 'https://twitter.com/triolospanchos',
    spotify: 'https://open.spotify.com/artist/3Ker27Wbb9OcUHGs54JIAz',
    deezer: 'https://www.deezer.com/mx/artist/16396',
    apple: 'https://music.apple.com/mx/artist/los-panchos/26172312',
    soundcloud: 'https://soundcloud.com/triolospanchos',
    tidal: 'https://listen.tidal.com/artist/4347',
    wiki: 'https://en.wikipedia.org/wiki/Los_Panchos',
    ticketmaster:'https://www.ticketmaster.com/los-panchos-tickets/artist/2250936',
    tiktok: 'https://www.tiktok.com/@triolospanchosoficial',
    napster: 'https://web.napster.com/artist/trio-los-panchos',
  },

  {
    title: 'Marco Antonio Solis',
    description:'Marco Antonio Solís Sosa es un cantautor, músico, compositor, actor y productor musical mexicano. Junto a su primo Joel Solís, fue fundador de la agrupación musical Los Bukis, del cual es vocalista, músico, productor y autor de la mayoría de sus canciones; al inicio tocaba los teclados y posteriormente los timbales y la guitarra. .',
    videourl:'http://youtube.com/playlist?list=PLl9yuNCZfI6pQFNQ90lEAdv8VoCOUvE8i',
    price: '$50',
    coverImg: 'MarcoAntonioSolis.jpg',
    category: 'Balada',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'http://www.marcoantoniosolis.com/',
    youtube: 'https://www.youtube.com/channel/UCIKg4QVg91aCWxXWlUkKDLw',
    facebook:'https://www.facebook.com/marcoantoniosolis/?eid=ARDZGcP8TaKskxpqO14J-o-2ZdAB_UU65p1ySVV2fFgb2ZsWGTAYo7NAzUnvpDSg9C_KCvXTmUYllfNG',
    instagram: 'https://www.instagram.com/marcoantoniosolis_oficial/',
    twitter: 'https://twitter.com/MarcoASolis',
    spotify: 'https://open.spotify.com/artist/3tJnB0s6c3oXPq1SCCavnd',
    deezer: 'https://www.deezer.com/mx/artist/9032',
    apple: 'https://music.apple.com/mx/artist/marco-antonio-sol%C3%ADs/332900',
    soundcloud: 'https://soundcloud.com/marco-antonio-solis-official',
    tidal: 'https://listen.tidal.com/artist/3675096',
    wiki: 'https://es.wikipedia.org/wiki/Marco_Antonio_Sol%C3%ADs',
    ticketmaster:
      'https://www.ticketmaster.com./marco-antonio-solis-tickets/artist/781016',
    tiktok: 'https://www.tiktok.com/@marcosantoniosolisoff?lang=es',
    napster: 'https://app.napster.com/artist/marco-antonio-solis',
  },
  {
    title: 'Luis Miguel',
    description:'Luis Miguel Gallego Basteri (San Juan, 19 de abril de 1970),conocido como Luis Miguel y apodado en ocasiones como «El Sol de México», es un cantante y productor musical mexicano.',
    videourl:'https://youtube.com/playlist?list=PLF-cRDh2mrlUMRA7E0-zntqkMrhNKwYri',
    price: 80,
    coverImg: 'luismiguel.jpg',
    category: 'Romantica',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'http://luismigueloficial.com/',
    youtube: 'https://www.youtube.com/c/LuisMiguelOfficial',
    facebook: 'https://www.facebook.com/luismiguelofficial',
    instagram: 'https://www.instagram.com/lmxlm/',
    twitter: 'https://twitter.com/LMXLM',
    spotify: 'https://open.spotify.com/artist/2nszmSgqreHSdJA3zWPyrW',
    deezer: 'https://www.deezer.com/mx/artist/6123',
    apple: 'https://music.apple.com/mx/artist/luis-miguel/336904',
    soundcloud: 'https://soundcloud.com/luismiguel_oficial',
    tidal: 'https://listen.tidal.com/artist/11993',
    wiki: 'https://en.wikipedia.org/wiki/Luis_Miguel',
    ticketmaster:
      'https://www.ticketmaster.com/luis-miguel-tickets/artist/762874',

    tiktok: 'https://www.tiktok.com/@lmxlm',
    napster: 'https://web.napster.com/artist/luis-miguel',
  },

  {
    title: 'Joan Sebastian',
    description:'José Manuel Figueroa, conocido artísticamente como Joan Sebastian, fue un cantante, compositor y actor mexicano, que fue conocido por el público bajo los sobrenombres de «El Rey del Jaripeo»,«El Poeta del Pueblo», «El Poeta de Juliantla» y «El Huracán del Sur.',
    videourl:'http://youtube.com/playlist?list=PL9CTSVO6wu7LNGcWzK-VheoJ1NavmEFjZ',
    price: '$50',
    coverImg: 'JoanSebastian.jpg',
    category: 'Norteño',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'http://joansebastianoficial.com/',
    youtube: 'https://www.youtube.com/channel/UC9oI0Vxnp-jJRH2StsXaIzQ',
    facebook: 'https://www.facebook.com/oficialjoansebastian',
    instagram: 'https://www.instagram.com/joansebastian/?hl=es-la',
    twitter: 'https://twitter.com/joansebastianof',
    spotify:'https://open.spotify.com/artist/7FsRH5bw8iWpSbMX1G7xf1?si=HX11vdfgQXuFFy6h5bdteg&nd=1',
    deezer: 'https://www.deezer.com/mx/artist/12141',
    apple: 'https://music.apple.com/mx/artist/joan-sebastian/295941',
    soundcloud: 'https://soundcloud.com/el-mimoso-luis-antonio-lopez',
    tidal: 'https://listen.tidal.com/artist/4672027',
    wiki: 'https://es.wikipedia.org/wiki/Joan_Sebastian',
    ticketmaster:'https://www.ticketmaster.com/joan-sebastian-tickets/artist/755195',
    tiktok: 'https://www.tiktok.com/@joansebastianoficial?lang=es',
    napster: 'https://web.napster.com/artist/joan-sebastian',
  },

  {
    title: 'Reyli',
    description:'Reyli Barba Arrocha es un cantautor y actor mexicano. Es conocido por haber sido el primer vocalista de la agrupación Elefante; siendo reemplazado por Jorge Guevara a partir de 2004. Desde su separación del grupo, trabaja como solista..',
    videourl: 'http://youtube.com/playlist?list=PL37D2450D17D43D48',
    price: '$50',
    coverImg: 'Reyli.jpg',
    category: 'Balada',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.reylibarbamusic.com/',
    youtube: 'https://www.youtube.com/channel/UCVk903Ollml-lwINrNo6K6w',
    facebook: 'https://www.facebook.com/ReyliBarbaOficial',
    instagram: 'https://www.instagram.com/reylibarbaoficial/',
    twitter: 'https://twitter.com/Reyli_Barba',
    spotify: 'https://open.spotify.com/artist/69BUYvpG9MbjCyIZfsFdhJ',
    deezer: 'https://www.deezer.com/mx/artist/194042',
    apple: 'https://music.apple.com/mx/artist/reyli-barba/20456368',
    soundcloud: 'https://soundcloud.com/reylibarba',
    tidal: 'https://listen.tidal.com/artist/3602829',
    wiki: 'https://es.wikipedia.org/wiki/Reyli_Barba',
    ticketmaster:'https://www.ticketmaster.com.mx/reyli-barba-boletos/artist/1197375',
    tiktok: 'https://www.tiktok.com/@reylibarbaoficial?lang=es',
    napster: 'https://app.napster.com/artist/reyli-barba',
  },
  {
    title: 'Top 100 Videos de Musica',
    description:
      '100 Videos Mixtos de Musica Regional Mexicana que hicieron el 2022 explotar con alegria , romance y sensaciones extraordinarias ..',
    videourl:
      'https://youtube.com/playlist?list=PLVZtocpycmEXG_s1xX7sml55L4wYfS4Uy',
    price: '$50',
    coverImg: 'musicamex.jpg',
    category: 'Exitos',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl:'https://djmagmx.com/edc-mexico-revela-alineacion-a-traves-musica/',
    youtube:'https://www.youtube.com/results?search_query=top+100songs+in+mexico',
    facebook: 'https://www.facebook.com/DjMagMex/',
    instagram: 'https://www.instagram.com/djmagmex/',
    twitter: 'https://twitter.com/DjMagMeX',
    spotify: 'https://open.spotify.com/playlist/4SF351Y9lTzATQkz4vrpXT',
    deezer: 'https://www.deezer.com/mx/playlist/10064138302',
    apple:'https://music.apple.com/us/playlist/top-100-mexico/pl.df3f10ca27b1479087de2cd3f9f6716b',
    soundcloud: 'https://soundcloud.com/djmagmx',
    tidal: 'https://listen.tidal.com/artist/4346014',
    wiki: 'https://es.wikipedia.org/wiki/Sony_Music_M%C3%A9xico',
    ticketmaster: 'https://www.ticketmaster.com.mx',
    tiktok: 'https://www.tiktok.com/@musica.mexicana_',
    napster: 'https://us.napster.com/blog/post/latino-collabs-en',
  },
  {
    title: 'Los Hermanos Mendoza',
    description:
      'Los Hermanos Mendoza son tres hermanos criados en Bakersfield, California, que crecieron escuchando a leyendas del country como Buck Owens y Merle Haggard. Inspirados por el inconfundible sonido de Bakersfield, han creado su propio estilo, fusionando la esencia del country clásico con un toque moderno y único. Su música rinde homenaje a las raíces del género mientras aporta una nueva energía a la escena country actual.',
    videourl:
      'https://youtube.com/playlist?list=PLZabTfEz7dbVou_2i4zyYpwBOsMUmnSeC&si=YrPjsk_5lytc7NKr',
    price: 50,
    coverImg: 'hermanosmendoza.jpg',
    category: 'Country',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://loshermanosmendoza.com/',
    youtube: 'https://www.youtube.com/@loshermanosmendoza',
    facebook: 'https://www.facebook.com/loshermanosm',
    instagram: 'https://www.instagram.com/loshermanos_mendoza',
    twitter: 'https://twitter.com/GeorgeStrait',
    spotify: 'https://open.spotify.com/artist/5GZYl0gsViF7ixhV6kfhPy',
    deezer: 'https://www.deezer.com/mx/artist/9568694',
    apple: 'https://music.apple.com/us/artist/los-hermanos-mendoza/1635684424',
    ticketmaster:
      'https://www.ticketmaster.com./',
    tiktok: 'https://www.tiktok.com/@hermanosmendozaoficial',
    napster: 'https://music.amazon.com.mx/artists/B07VMF9QHF/',
  },
  {
    title: 'Grupo Bronco',
    description:'Bronco es una agrupación de música regional mexicana especializada en el estilo grupero y famosa por sus baladas, cumbias, rancheras y huapangos. Sus miembros son originarios de Apodaca, Nuevo León. El grupo ha lanzado hasta la actualidad más de 20 álbumes..',
    videourl: 'https://youtube.com/playlist?list=PLswTIamHo0hXAZPqeahGNF7-y7a6a6qPp&si=R5J4uk9jdVyWYlQ4',
    price: '$50',
    coverImg: 'bronco.jpeg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://broncoesbronco.com/',
    youtube: 'https://www.youtube.com/channel/UCmXveBEdi2vv42Qs3sQYkow',
    facebook: 'https://www.facebook.com/grupobronco/',
    instagram: 'https://www.instagram.com/grupobronco/',
    twitter: 'https://twitter.com/Grupo_Bronco',
    spotify: 'https://open.spotify.com/user/31sb73idiytc2hl5vscywdaff4ue',
    deezer: 'https://www.deezer.com/mx/artist/269769',
    apple: 'https://music.apple.com/mx/artist/bronco/74585929',
    soundcloud: 'https://soundcloud.com/bronco-official',
    tidal: 'https://listen.tidal.com/artist/3617245',
    wiki: 'https://es.wikipedia.org/wiki/Bronco_(banda)',
    ticketmaster: 'https://www.ticketmaster.com/bronco-tickets/artist/743616',
    tiktok: 'https://www.tiktok.com/@grupobronco',
    napster: 'https://web.napster.com/artist/bronco',
  },
  {
    title: 'Pedro Infante',
    description:'Pedro Infante Cruz (Mazatlán, Sinaloa, 18 de noviembre de 1917-Mérida, Yucatán, 15 de abril de 1957) fue un actor y cantante mexicano. Es considerado como uno de los actores más recordados del cine en México.Por su actuación en la película Tizoc (1956), fue ganador de un Oso de Plata​ del Festival Internacional de Cine de Berlín en la categoría a «mejor actor principal», y también obtuvo un premio Globo de Oro​ por mejor película extranjera, el cual se le fue otorgado por la prensa extranjera acreditada en Hollywood..',
    videourl:'https://youtube.com/playlist?list=PLF-cRDh2mrlVODBGJurCWQdYWZ7VH_Nhd',
    price: '$50',
    coverImg: 'pedroinfante.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl:'https://www.biografiasyvidas.com/biografia/i/infante_pedro.htm#:~:text=Pedro%20Infante%20%28Mazatl%C3%A1n%2C%20Sinaloa%2C%201917%20-%20M%C3%A9rida%2C%20Yucat%C3%A1n%2C,musical%20que%20actuaba%20en%20la%20localidad%20de%20Guasave.',
    youtube: 'https://www.youtube.com/channel/UCCZRmXAChQJF1P6xsX28TTQ',
    facebook: 'https://www.facebook.com/profile.php?id=100052259945722',
    instagram: 'https://www.instagram.com/pedro_infante_official/',
    twitter: 'https://twitter.com/Pedro_Infante1',
    spotify: 'https://open.spotify.com/artist/7y33enVLfDvft6HGNmcxdV',
    deezer: 'https://www.deezer.com/mx/artist/264106',
    apple: 'https://music.apple.com/mx/artist/pedro-infante/2137889',
    soundcloud: 'https://soundcloud.com/pedro-infante-official',
    tidal: 'https://listen.tidal.com/artist/13256',
    wiki: 'https://es.wikipedia.org/wiki/Pedro_Infante',
    ticketmaster:
      'https://www.noroeste.com.mx/entretenimiento/espectaculos/llenaran-de-tributos-a-pedro-infante-PVNO1078632',
    napster: 'https://web.napster.com/artist/pedro-infante',
    tiktok: 'https://www.tiktok.com/@pedroinfanteidolo',
  },
  {
    title: 'Ernesto Cardenas Bazaldua',
    description:'Ernesto Bazaldua  es un Cantautor de Origen Mexicano cual  radica en Guadalajara, Jalisco, Mexico, Su   musica es versatil,Regional y sus exitos son ,1:Por Ser Pobre, 2:Tu Conciencia Te hara Llorar, 3. Dia de las Madres 4.Ese Soy Yo 5: Te Esperare 7.Con una Llamada 7. Se te acabado el juego 8.Libro Cerrado 9.Tomados de la mano, 10.Carta de Retiro.',
    videourl: 'https://youtube.com/playlist?list=UUF0QfCEV_8ZpA0B2Yv56xBg',
    price: '$50',
    coverImg: 'ErnestoCardenas.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl:'https://wynk.in/music/album/las-inspiraciones-de-ernesto-c%C3%A1rdenas/bl_3617050935625',
    youtube: 'https://www.youtube.com/@ernestocardenas5939',
    facebook: 'https://www.facebook.com/ernesto.cardenasbazaldua.1',
    instagram: 'https://www.instagram.com/ernestocardenasbazaldua/',
    twitter: '',
    spotify: 'https://open.spotify.com/artist/7KZNDFnwppqWlfoVcCh1bg',
    deezer: 'https://www.deezer.com/en/artist/1822121',
    apple:
      'https://music.apple.com/us/album/las-inspiraciones-de-ernesto-c%C3%A1rdenas/1644034684',
    soundcloud: 'https://soundcloud.com/search?q=Ernesto%20Crdenas%20Bazaldua',
    tidal: 'https://listen.tidal.com/artist/6254720',
    wiki: 'https://www.amazon.co.uk/Con-una-Llamada/dp/B0BDKTQJXJ',
    ticketmaster: 'https://www.viagogo.com.mx/',
    tiktok: 'https://www.tiktok.com/@ernestocardenasba',
    napster: 'https://music.amazon.com.mx/albums/B0BDKM5VGD',
  },
  {
    title: 'Yahritza y su Esencia',
    description:'Yahritza y su Esencia (Yahritza and Her Essence) is an American trio from Washington states Yakima Valley who specialize in regional Mexican music; specifically the urban sierreño subgenre. The band are three siblings: Yahritza Martínez (vocals and acoustic guitar), Armando (Mando) Martínez (twelve-string guitar), and Jairo Martínez (acoustic bass).For the week of April 9, 2022, their song "Soy el Único" appeared on the Billboard Global 200.[3] Yahritza wrote the song when she was fourteen.[1] At the 23rd Annual Latin Grammy Awards, the trio was nominated for Best New Artist as well as for Best Norteño Album for Obsessed, their debut album.',
    videourl: 'https://youtube.com/playlist?list=OLAK5uy_mAQda0846gfPA-6vMuDlpyya5crT2K9E8&si=Wbri6XQ0DMvgZnNR',
    price: '$50',
    coverImg: 'yahritzia.jpg',
    category: 'Regional',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl:'https://sonymusic.com.mx/artist/yahritza-y-su-esencia/',
    youtube: 'https://www.youtube.com/channel/UC7ptwo_0Npl5Bji31j868fA',
    facebook: 'https://www.facebook.com/YahritzaYSuEsencia',
    instagram: 'https://www.instagram.com/yahritzaysuesencia',
    twitter: 'https://x.com/Yahritza_YSE',
    spotify: 'https://open.spotify.com/artist/51ZSh80McCt7vbqHouzW0A?autoplay=true',
    deezer: 'https://www.deezer.com/mx/artist/164599407',
    apple:'https://music.apple.com/mx/artist/yahritza-y-su-esencia/1613375172',
    soundcloud: 'https://soundcloud.com/yahritza',
    tidal: 'https://listen.tidal.com/artist/31342478',
    wiki: 'https://en.wikipedia.org/wiki/Yahritza_y_su_Esencia',
    ticketmaster: 'https://www.viagogo.com.mx/',
    tiktok: 'https://www.tiktok.com/discover/yahritzia?lang=en',
    napster: 'https://music.amazon.com.mx/artists/B09WCWB3WN/yahritza-y-su-esencia',
  },
  {
    title: 'Alejandro Fernandez',
    description:'Alejandro Fernández Abarca es un cantante de música ranchera y pop latino mexicano, hijo del fallecido cantante ranchero Vicente Fernández. En un principio se especializó en tipos tradicionales de música regional mexicana como mariachi. Posteriormente se ha diversificado hacia el pop latino con toques urbanos, la balada y el bolero.',
    videourl: 'http://youtube.com/playlist?list=PLEB89B6DF1EE964B5',
    price: '$50',
    coverImg: 'AlejandroFernandez.jpg',
    category: 'Mariachi',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://alejandrofernandez.com/',
    youtube: 'https://www.youtube.com/channel/UC0K-1_31jfkcA4Nd294gMyA',
    facebook: 'https://www.facebook.com/alejandrofernandezoficial',
    instagram: 'https://www.instagram.com/alexoficial/',
    twitter: 'https://twitter.com/alexoficial',
    spotify:'https://open.spotify.com/artist/6sq1yF0OZEWA4xoXVKW1L9?si=Nbmjb1PvTiGojQaSs1z1cQ&nd=1',
    deezer: 'https://www.deezer.com/mx/artist/8794',
    apple: 'https://music.apple.com/mx/artist/alejandro-fern%C3%A1ndez/893583',
    soundcloud: 'https://soundcloud.com/alejandro-fernandez-official',
    tidal: 'https://listen.tidal.com/artist/1410',
    wiki: 'https://en.wikipedia.org/wiki/Alejandro_Fern%C3%A1ndez',
    ticketmaster:'https://www.ticketmaster.com/alejandro-fernandez-tickets/artist/761444',
    tiktok: 'https://www.tiktok.com/@alejandrofernandezfans',
    napster: 'https://web.napster.com/artist/alejandro-fernandez',
  },
  {
    title: 'Alex Fernandez',
    description:'Saltó a la fama en las redes sociales como hijo del reconocido cantante mexicano Alejandro Fernández. Ha heredado un seguimiento de Instagram de más de 650.000 fanáticos de miembros famosos de su familia. También es cantante y ha grabado dos discos. Nacido el 4 de noviembre de 1993, Alex Fernández Jr. es oriundo de México. Al igual que en 2022, la edad de Alex Fernández Jr. es de 29 años. Consulte a continuación para obtener más detalles sobre Alex Fernández Jr.. Esta página arrojará luz sobre la biografía, wiki, edad, cumpleaños, detalles familiares, aventuras, controversias, casta, altura, peso, rumores y hechos menos conocidos de Alex Fernández Jr. , y más.',
    videourl:'https://youtube.com/playlist?list=PLutFSHdaf1CL5TLFaNFDiAuYjsUoOlTKV',
    price: 50,
    coverImg: 'alexfernandez.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl:'https://www.seitrack.mx/alexfernandez?fbclid=IwAR0gfNb2bj5mfqgc1tcd88sERPHwgp5OY5qkOxjeBh8NuqCA74x8LkIGqBI',
    youtube: 'https://www.youtube.com/channel/UC5-ZtcsyTQNjrsR_9yRCZJg',
    facebook: 'https://www.facebook.com/AlexFdezMusica/',
    instagram: 'https://www.instagram.com/alexfernandez.g/',
    twitter: 'https://twitter.com/AlexFdezMusica',
    spotify: 'https://open.spotify.com/artist/4Xwvz864z2uP3bwPcjKJjC',
    deezer: 'https://www.deezer.com/mx/artist/9896010',
    apple: 'https://music.apple.com/mx/artist/alex-fern%C3%A1ndez/1453744801',
    soundcloud: 'https://soundcloud.com/alexfernandez-music',
    tidal: 'https://listen.tidal.com/artist/7622411',
    wiki: 'https://celebs.filmifeed.com/wiki/alex-fernandez-jr/',
    ticketmaster:'https://www.ticketmaster.com/alex-fernandez-tickets/artist/2729965',
    tiktok: 'https://www.tiktok.com/@alexfernandez.g?lang=es',
    napster: 'https://us.napster.com/artist/alex-fernandez-2',
  },
  {
    title: 'Pepe Aguilar',
    description:'José Antonio Aguilar Jiménez, más conocido como Pepe Aguilar, es un cantante, compositor, músico, productor y empresario mexicano. Desde muy joven, Aguilar acompañó de gira a sus padres, los cantantes y actores mexicanos Antonio Aguilar y Flor Silvestre. Ahora hace lo mismo con sus propios hijos, Leonardo Aguilar y Ángela Aguilar, quienes también han seguido los pasos de su padre y abuelos..',
    videourl:'http://youtube.com/playlist?list=OLAK5uy_km79fnJX9-enVlkDxmmUczWzgFBYo-mbY',
    price: '$50',
    coverImg: 'pepeaguilar.jpg',
    category: 'Mariachi',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://pepeaguilar.com/',
    youtube: 'https://www.youtube.com/c/pepeaguilaroficial',
    facebook: 'https://www.facebook.com/pepeaguilaroficial',
    instagram: 'https://www.instagram.com/pepeaguilar_oficial/',
    twitter: 'https://twitter.com/PepeAguilar',
    spotify: 'https://open.spotify.com/artist/03Yb3iBy9GCifXiATEFcit',
    deezer: 'https://www.deezer.com/mx/artist/8793',
    apple: 'https://music.apple.com/mx/artist/pepe-aguilar/21421637',
    soundcloud: 'https://soundcloud.com/search?q=Pepe%20Aguilar',
    tidal: 'https://listen.tidal.com/artist/3506026',
    wiki: 'https://en.wikipedia.org/wiki/Pepe_Aguilar',
    ticketmaster:'https://www.ticketmaster.com/pepe-aguilar-tickets/artist/754764',
    tiktok: 'https://www.tiktok.com/@pepeaguilar_oficial',
    napster: 'https://web.napster.com/artist/pepe-aguilar',
  },
  {
    title: 'Angela Aguilar',
    description:'Ángela Aguilar Álvarez (Los Ángeles, California; 8 de octubre de 2003), es una cantante mexicana-estadounidense de música regional mexicana. Obtuvo un notable reconocimiento después de interpretar La Llorona en la 19.ª Entrega Anual de los Premios Grammy Latinos en 2018. Es nieta de El Charro de México, Antonio Aguilar.',
    videourl:'http://youtube.com/playlist?list=OLAK5uy_kSBDJlpXRi2Cy2v5fYI8ag4M1ku2STWAE',
    price: '$50',
    coverImg: 'AngelaAguilar.jpg',
    category: 'Mariachi',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.angelaaguilaroficial.com/',
    youtube: 'https://www.youtube.com/channel/UCugX5B6n1jtQq2ihzhRk-Ag',
    facebook: 'https://www.facebook.com/AngelaAguilarOficial/',
    instagram: 'https://www.instagram.com/angela_aguilar_/?hl=en',
    twitter: 'https://twitter.com/AngelaAguilar__',
    spotify: 'https://open.spotify.com/artist/3abT87tqQ4Q5PA5nw6CYyH',
    deezer: 'https://www.deezer.com/mx/artist/4028765',
    apple: 'https://music.apple.com/mx/artist/%C3%A1ngela-aguilar/565880444',
    soundcloud: 'https://soundcloud.com/angelaaguilarofficial',
    tidal: 'https://listen.tidal.com/artist/4734467',
    wiki: 'https://en.wikipedia.org/wiki/%C3%81ngela_Aguilar',
    ticketmaster:'https://www.ticketmaster.com/angela-aguilar-tickets/artist/2584974',
    tiktok: 'https://www.tiktok.com/@angelaaguilar676',
    napster: 'https://web.napster.com/artist/art.66144484',
  },
  {
    title: 'Cristian Nodal',
    description:'Christian Jesús González Nodal (Caborca , Sonora; 11 de enero de 1999), conocido como Christian Nodal, es un cantante, compositor mexicano. Su primer sencillo, «Adiós amor», publicado en 2016 bajo el sello discográfico Fonovisa, lo lanzó a la fama en diversos medios de comunicación en México y Estados Unidos.',
    videourl:'https://youtube.com/playlist?list=PL2cg72xd9U-ioO2IpH7OZrT43hVgC6fmm',
    price: 80,
    coverImg: 'nodal.jpg',
    category: 'Mariachi',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://shop.christiannodal.com/',
    youtube: 'https://www.youtube.com/channel/UCtqOng3GVhQVu1Gl-3UlyAQ',
    facebook: 'https://www.facebook.com/christiannodaloficialmx/',
    instagram: 'https://www.instagram.com/nodal/',
    twitter: 'https://twitter.com/elnodal?lang=en',
    spotify:'https://open.spotify.com/artist/0XwVARXT135rw8lyw1EeWP?si=xMgobcktQD6v1nbtGIxGhQ&nd=1',
    deezer: 'https://www.deezer.com/mx/artist/9763952',
    apple: 'https://music.apple.com/mx/artist/christian-nodal/1079597775',
    soundcloud: 'https://soundcloud.com/christiannodal',
    tidal: 'https://listen.tidal.com/artist/7745729',
    wiki: 'https://en.wikipedia.org/wiki/Christian_Nodal',
    ticketmaster:'https://www.ticketmaster.com/christian-nodal-tickets/artist/2405178',
    tiktok: 'https://www.tiktok.com/@christiannodal',
    napster: 'https://web.napster.com/artist/christian-nodal',
  },
  {
    title: 'Intocable',
    description:'Intocable es un grupo estadounidense de origen mexicano de música tejana y norteña de Zapata, Texas, Estados Unidos, fundado a principios de la década de los 90 por Ricky Muñoz y René Martínez.1​ Dentro de algunos años, la banda logró subir a la cima de la música tejana y norteña, con un estilo musical que fusionó la música conjunto de Texas y los ritmos folclóricos de la música norteña con baladas de letras modernas.',
    videourl:'https://youtube.com/playlist?list=OLAK5uy_mEpEPj__3rc-1-CiPwYP0GS-JE_jY93CA',
    price: null,
    coverImg: 'intocable.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://grupointocable.com/',
    youtube: 'https://www.youtube.com/channel/UCvQcMlXzM9JdAgzkBo1B0Ew',
    facebook: 'https://www.facebook.com/grupointocable/',
    instagram: 'https://www.instagram.com/grupointocable/?hl=en',
    twitter:
      'https://twitter.com/grupointocable?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor',
    spotify: 'https://open.spotify.com/artist/108moq3rq6bm1M4Ypz0J02',
    deezer: 'https://www.deezer.com/mx/artist/16644',
    apple: 'https://music.apple.com/mx/artist/intocable/549010',
    soundcloud: 'https://soundcloud.com/intocable-official',
    tidal: 'https://listen.tidal.com/artist/56242',
    wiki: 'https://es.wikipedia.org/wiki/Intocable_(banda)',
    ticketmaster: 'https://www.ticketmaster.com.mx/search?q=Intocable',
    tiktok: 'https://www.tiktok.com/@grupo_intocable?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000SA1FUQ/intocable',
  },
  {
    title: 'Vicente Fernandez',
    description:'Vicente Fernández Gómez, también conocido como El Charro de Huentitán o Chente, fue un cantante de ranchera, empresario, productor discográfico y actor mexicano. Su trabajo en la música le valió dos premios Grammy, ocho premios Grammy Latinos, catorce premios Lo Nuestro y una estrella en el paseo de la fama de Hollywood. En abril del 2010, alcanzó la cifra de 60 millones de copias vendidos en todo el mundo. Su hijo, Alejandro Fernández, también es cantante.',
    videourl: 'https://youtube.com/playlist?list=PL47228A7CBC410B5F',
    price: '$50',
    coverImg: 'VicenteFernandez.jpg',
    category: 'Mariachi',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.vicentefernandez.mx/',
    youtube: 'https://www.youtube.com/channel/UCwPTC2n6D8asyi1G5uBZlpw',
    facebook: 'https://www.facebook.com/VicenteFernandezOficial',
    instagram: 'https://www.instagram.com/_vicentefdez/',
    twitter: 'https://twitter.com/_VicenteFdez',
    spotify: 'https://open.spotify.com/artist/4PPoI9LuYeFX8V674Z1R6l',
    deezer: 'https://www.deezer.com/mx/artist/8798',
    apple: 'https://music.apple.com/mx/artist/vicente-fern%C3%A1ndez/6742830',
    soundcloud: 'https://soundcloud.com/vicentefernandez',
    tidal: 'https://listen.tidal.com/artist/4030361',
    wiki: 'https://en.wikipedia.org/wiki/Vicente_Fern%C3%A1ndez',
    ticketmaster:'https://www.ticketmaster.com.mx/vicente-fernandez-boletos/artist/754927',
    tiktok: 'https://www.tiktok.com/@_vicentefdez',
    napster: 'https://web.napster.com/artist/vicente-fernandez',
  },
  {
    title: 'Antonio Aguilar',
    description:'Don Antonio Aguilar representa y encarna a la música mexicana. Es un símbolo y un referente cuando se habla de nuestras raíces culturales, ya sea con su amplio y exitoso repertorio musical o en sus inolvidables trabajos cinematográficos. Por algo orgullosamente se le conoce como El Charro de México.',
    videourl:'http://youtube.com/playlist?list=PLfjaVNeEP9fSdn5r0C6thkKVPs23g9rZ2',
    price: '$50',
    coverImg: 'AntonioAguilar.jpg',
    category: 'Mariachi',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://found.ee/mmq-antonioaguilar-digital-lat',
    youtube: 'https://music.youtube.com/channel/UCrudP827nGhBGLHCUDQzSPg',
    facebook: 'https://www.facebook.com/AntonioAguilarFans1/',
    instagram: 'https://www.instagram.com/el_charro_de.mexico/',
    twitter: '',
    spotify: 'https://open.spotify.com/artist/0PN0fbe41KbuzlRYnoajNm',
    deezer: 'https://www.deezer.com/mx/artist/96684',
    apple: 'https://music.apple.com/mx/artist/antonio-aguilar/6545576',
    soundcloud: 'https://soundcloud.com/antonioaguilarofficial',
    tidal: 'https://listen.tidal.com/artist/3665841',
    wiki: 'https://en.wikipedia.org/wiki/Antonio_Aguilar',
    ticketmaster:'https://www.ticketmaster.com/antonio-aguilar-tickets/artist/754762',
    tiktok: 'https://www.tiktok.com/@antonioaguilar.2022',
    napster: 'https://web.napster.com/artist/antonio-aguilar',
  },
  {
    title: 'Grupo Frontera',
    description:'Grupo Frontera es una banda musical estadounidense formada en Edinburg, Texas, en 2022. Está compuesta por: Adelaido «Payo» Solís III, Juan Javier Cantú, Julián Peña Jr., Alberto «Beto» Acosta, Carlos Guerrero y Brian Ortega.1​ Se especializan en música regional mexicana; específicamente en el subgénero de música norteña estilo regiomontana. Recibieron reconocimiento internacional en la década del 2020.2​3​ Su debut comenzó después de interpretar la canción «No se va» de la banda colombiana de Morat.',
    videourl:'https://youtube.com/playlist?list=PL_u4aYYWfB51LCb0oW9vpYGfCIiy4IL0G&si=ftQB_EoEjpZEWBTe',
    price: '$50',
    coverImg: 'frontera.jpg',
    category: 'Regional',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://grupo-frontera.com/',
    youtube: 'https://www.youtube.com/channel/UCKsN6xyJ2w8g7p4p9apXkYQ',
    facebook: 'https://www.facebook.com/fronteragrupo',
    instagram: 'https://www.instagram.com/grupofrontera',
    twitter: 'https://x.com/frontera_grupo',
    spotify: 'https://open.spotify.com/artist/6XkjpgcEsYab502Vr1bBeW',
    deezer: 'https://www.deezer.com/mx/artist/7201102',
    apple: 'https://music.apple.com/mx/artist/grupo-frontera/1613772487',
    soundcloud: 'https://soundcloud.com/grupofrontera',
    wiki: 'https://es.wikipedia.org/wiki/Grupo_Frontera',
    ticketmaster:'https://www.ticketmaster.com/grupo-frontera-tickets/artist/2942293',
    tiktok: 'https://www.tiktok.com/@grupofrontera',
    napster: 'https://music.amazon.com.mx/artists/B00QHEN5NC',
  },
]

export default CardData2
